import React, { useState, useEffect } from 'react';

interface EditQueryModalProps {
  isOpen: boolean;
  onClose: () => void;
  query: any; // You can replace 'any' with your Query type if defined
  user: any;  // You can replace 'any' with your User type if defined
  onSave: (updatedQuery: any) => void;
  onDelete: (id: string) => void;
}

const EditQueryModal: React.FC<EditQueryModalProps> = ({
  isOpen,
  onClose,
  query,
  user,
  onSave,
  onDelete,
}) => {
  const [status, setStatus] = useState(query?.status || 'pending');
  const [remarks, setRemarks] = useState(query?.remarks || '');
  const isAdmin = user?.role === 'admin';

  useEffect(() => {
    if (query) {
      setStatus(query.status);
      setRemarks(query.remarks);
    }
  }, [query]);

  if (!isOpen || !query) return null;

  const handleSave = () => {
    onSave({ ...query, status, remarks });
  };

  const handleDelete = () => {
    onDelete(query.id);
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-30 z-50">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-lg p-6">
        <h2 className="text-xl font-bold mb-4">Edit Query</h2>
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium">Status</label>
            <select
              className="input-field mt-1"
              value={status}
              onChange={e => setStatus(e.target.value)}
            >
              <option value="pending">Pending</option>
              <option value="resolved">Resolved</option>
              <option value="unsolved">Unsolved</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium">Remarks</label>
            <textarea
              className="input-field mt-1"
              value={remarks}
              onChange={e => setRemarks(e.target.value)}
              rows={2}
            />
          </div>
        </div>
        <div className="flex justify-end gap-2 mt-6">
          <button className="btn-secondary" onClick={onClose}>Cancel</button>
          {isAdmin && (
            <button className="btn-secondary text-red-600" onClick={handleDelete}>Delete</button>
          )}
          <button className="btn-primary" onClick={handleSave}>Save</button>
        </div>
      </div>
    </div>
  );
};

export default EditQueryModal;
